import React, { Component } from "react";
import qs from "qs";
import { useLocation, useHistory } from "react-router-dom";
import ResultsPanel from "../../Components/DirectoryPanel/ResultsPanel";
import FilterPanel from "../../Components/DirectoryPanel/FilterPanel";
import FilterButton from "../../Components/DirectoryPanel/FilterButton";
import CurrentRefinementList from "../../Components/DirectoryPanel/CurrentRefinementList";
import SearchInput from "../../Components/DirectoryPanel/SearchInput";
import DirectoryPagination from "../../Components/DirectoryPanel/DirectoryPagination";
import algoliasearch from "algoliasearch/lite";
import { InstantSearch, Configure, SearchBox } from "react-instantsearch-dom";
import {Trans, Translation} from 'react-i18next';

const searchClient = algoliasearch(
  "6KMP52GB5X",
  "a4bb5f7de85b6dc3b2313ece00f93394"
);
const createURL = (state) => `?${qs.stringify(state)}`;
const DEBOUNCE_TIME = 700;
const DIRECTORY_INDEX = window.directory_index



const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : "";

const urlToSearchState = (location) => qs.parse(location.search.slice(1));

export default class Directory extends Component {
  constructor(props) {
    super(props);
    this.setStateId = React.createRef();
    this.state = {
      searchState: urlToSearchState(this.props.location),
      locationState: null,
    };
  }

  componentDidUpdate(prevProps) {
    // const nextSearchState = urlToSearchState(this.props.location);
    // if (
    //   JSON.stringify(this.state.searchState) !== JSON.stringify(nextSearchState)
    // ) {
    //   this.setState({ searchState: nextSearchState });
    // }
  }

  _onSearchStateChange = (nextSearchState) => {
    clearTimeout(this.setStateId.current);

    this.setStateId.current = setTimeout(() => {
      this.props.history.push(
        searchStateToUrl(this.props.location, nextSearchState),
        nextSearchState
      );
    }, DEBOUNCE_TIME);

    this.setState({ searchState: nextSearchState });
  };

  _onLocationStateSearch = (locationState) => {
    this.setState({ locationState });
  };

  submitHandler(e) {
    e.preventDefault();
  }



  render() {
    return (
      <InstantSearch
        searchClient={searchClient}
        createURL={(searchState) => `?q=${searchState.query}`}
        indexName={DIRECTORY_INDEX}
        searchState={this.state.searchState}
        onSearchStateChange={this._onSearchStateChange}
      >
        <div className="main__body">
          <div className="main__inner main__inner-results">
            <section className="section-results">
              <div className="shell shell--alt">
                <div className="section__inner">
                  <FilterButton />
                  <div className="form-search js-form-search filters-open js-filters-panel">
                      <div className="form__head">
                        <div className="form__row">
                          <label for="" className="form__label">
                            <Trans>Directory.Search.Label</Trans>
                          </label>

                          <SearchInput />
                        </div>
                        <CurrentRefinementList />
                      </div>
                      <div className="form__body">
                        <aside className="form__aside">
                          <FilterPanel />
                        </aside>
                        <div className="form__content">
                          <ResultsPanel />
                          <DirectoryPagination />
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </InstantSearch>
    );
  }
}
